import { translateUi } from "./i18n.ts";
import { ApiRequestError } from "./api-read-retry.ts";

// The first-party host can delay a valid cookie check before the direct transport is available.
export const initialSessionCheckTimeoutMs = 45_000;

export function isExpiredSession(error: unknown) {
  return error instanceof ApiRequestError && error.status === 401;
}

export async function confirmLoginSession<T extends { user: { id: string } }>(expectedUserId: string, read: () => Promise<T>): Promise<T> {
  try {
    const result = await read();
    if (result.user.id !== expectedUserId) throw new ApiRequestError(translateUi("Sesioni nuk përputhet me hyrjen.", "The session does not match the sign-in."), 401);
    return result;
  } catch (error) {
    if (isExpiredSession(error)) throw new Error(translateUi("Sesioni nuk u verifikua në këtë browser. Lejo cookies për këtë faqe dhe provo përsëri.", "The session could not be verified in this browser. Allow cookies for this site and try again."));
    throw error;
  }
}

export async function checkSession<T>(read: () => Promise<T>): Promise<
  { status: "authenticated"; value: T } | { status: "guest" | "unavailable" }
> {
  try { return { status: "authenticated", value: await read() }; }
  catch (error) { return { status: isExpiredSession(error) ? "guest" : "unavailable" }; }
}
